// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__1gjT2","addRow":"styles_addRow__2x1tI"};